module.exports = __webpack_public_path__ + "img/hook_PEWAG_FW_4.62b59f2b.png";